import { THEME_LIGHT } from '@/constant/theme-key'

const useThemeStore = defineStore('theme', () => {
  const themeType = ref<string>(THEME_LIGHT)

  function changeThemeType(_theme: string) {
    themeType.value = _theme
  }

  return {
    themeType,
    changeThemeType,
  }
}, {
  // https://prazdevs.github.io/pinia-plugin-persistedstate/zh/guide/config.html
  persist: {
    key: 'stp-front-theme',
  },
})

export default useThemeStore
